<template>
  <StoreLocatorConfigSection :title="$t('message.storeLocator.photos.title')">
    <div class="sl-photos">
      <i18n
        path="message.storeLocator.photos.description"
        tag="div"
        class="sl-photos__description"
      >
        <template v-slot:0>
          <router-link :to="{ name: 'photos' }">{{
            $t("message.storeLocator.photos.descriptionLink")
          }}</router-link>
        </template>
      </i18n>
    </div>
  </StoreLocatorConfigSection>
</template>

<script>
import StoreLocatorConfigSection from "@/components/StoreLocator/StoreLocatorConfigSection";

export default {
  name: "StoreLocatorConfigPhotos",
  components: {
    StoreLocatorConfigSection
  }
};
</script>

<style lang="scss" scoped>
.sl-photos {
  margin-bottom: $spacing * 3;

  &__description {
    @include font-size(14px);
    line-height: 17px;
    font-weight: 500;
    color: rgba($dark-blue-3, 0.9);
  }
}
</style>
